
/**
 * Controller para la busqueda
 * @author jkudla
 */
angular.module('mapes').controller('SearchPreinscripcioCtrl', function (
  $rootScope,
  $scope,
  CentresPreinscripcio,
  DataService,
  Comarques,
  EnsenyamentsData,
  EnsenyamentsPreinscripcioData,
  NotificationsService,
  SharedProperties
) {

  $scope.button = {
    text: "Cerca",
    cssClass: '',
    hideLoading: true,
    textLoading: 'Carregant ',
    cssClassLoading: 'loading'
  };

  var isEmpty = function (array) {
    if (!_.isArray(array)) {
      return true;
    }

    return array.length === 0;
  };

  var extractField = function (parameters, field) {
    if (!_.isArray(parameters)) {
      parameters = [parameters];
    }

    if (_.isArray(parameters)) {
      return _.compact(_.uniq(_.flatten(_.map(parameters, field))));
    }
  };

  var setParametersForCfp = function (ariFilter, paramsMapes) {
    paramsMapes.cfp = {
      cicle: [],
      families: [],
      estudis: [],
      torns: [],
      nivells: [],
      naturaleses: []
    };

    var CFP = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'CFP';
      });
      CFP = ariFilter = ariFilter[index];
    }
    if (CFP === null || CFP === undefined) {
      return;
    }

    if (!isEmpty(ariFilter.cicles)) {
      paramsMapes.cfp.cicle = extractField(CFP.cicles, 'codi');

      if (!isEmpty(ariFilter.families)) {
        paramsMapes.cfp.families = extractField(CFP.families, 'codis');

        if (!isEmpty(ariFilter.estudis)) {
          paramsMapes.cfp.estudis = extractField(CFP.estudis, 'codis');
        }
      }
    } else {
      paramsMapes.cfp.cicle = extractField(
        _.compact(_.flatten(_.map(ariFilter.tipus.subnodes, 'subnodes'))),
        'codi');
    }

    if (!isEmpty(ariFilter.torns)) {
      paramsMapes.cfp.torns = extractField(ariFilter.torns, 'id');
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.cfp.nivells = extractField(ariFilter.nivells, 'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.cfp.naturaleses = extractField(ariFilter.naturaleses,
        'id');
    }
    return;
  };

  var setParametersForCfa = function (ariFilter, paramsMapes) {
    paramsMapes.cfa = {
      cicle: [],
      families: [],
      estudis: [],
      torns: [],
      nivells: [],
      naturaleses: []
    };

    var CFA = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return ['CFA', 'ART'].indexOf(o.tipus.codi) > -1;
      });
      CFA = ariFilter = ariFilter[index];
    }
    if (CFA === null || CFA === undefined) {
      return;
    }

    if (!isEmpty(ariFilter.cicles)) {
      paramsMapes.cfa.cicle = extractField(CFA.cicles, 'codi');

      if (!isEmpty(ariFilter.families)) {
        paramsMapes.cfa.families = extractField(CFA.families, 'codis');

        if (!isEmpty(ariFilter.estudis)) {
          paramsMapes.cfa.estudis = extractField(CFA.estudis, 'codis');
        }
      }
    } else {
      paramsMapes.cfa.cicle = extractField(
        _.compact(_.flatten(_.map(ariFilter.tipus.subnodes, 'subnodes'))),
        'codi');
    }

    if (!isEmpty(ariFilter.torns)) {
      paramsMapes.cfa.torns = extractField(ariFilter.torns, 'id');
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.cfa.nivells = extractField(ariFilter.nivells, 'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.cfa.naturaleses = extractField(ariFilter.naturaleses,
        'id');
    }
    return;
  };

  var setParametersForBatxillerat = function (ariFilter, paramsMapes) {
    paramsMapes.batxillerat = {
      //codi: '',
      estudis: [],
      nivells: [],
      naturaleses: [],
      regims: []
    };

    var batxillerat = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'BATXLOE';
      });
      batxillerat = ariFilter = ariFilter[index]
    }

    if (batxillerat === null || batxillerat === undefined) {
      return;
    }

    /* if (ariFilter.tipus) {
      paramsMapes.batxillerat.codi = ariFilter.tipus.codi;
    } */

    if (!isEmpty(ariFilter.estudis)) {
      paramsMapes.batxillerat.estudis = extractField(ariFilter.estudis,
        'codi');
    } else {
      paramsMapes.batxillerat.estudis = _.map(
        JSON.parse(localStorage.getItem('BATXLOE')), 'codi');
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.batxillerat.nivells = extractField(ariFilter.nivells,
        'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.batxillerat.naturaleses = extractField(
        ariFilter.naturaleses, 'id');
    }

    if (!isEmpty(ariFilter.regims)) {
      paramsMapes.batxillerat.regims = extractField(ariFilter.regims, 'id');
    }

    return;
  };

  var setParametersForEinf = function (ariFilter, paramsMapes) {
    paramsMapes.einf = {
      nivells: [],
      naturaleses: [],
      codis: ""
    };

    var einf = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'EINFLOE3-6';
      });
      einf = ariFilter = ariFilter[index]
    }

    if (einf === null || einf === undefined) {
      return;
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.einf.nivells = extractField(ariFilter.nivells,
        'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.einf.naturaleses = extractField(
        ariFilter.naturaleses, 'id');
    }

    if (ariFilter.tipus.codi !== "") {
      paramsMapes.einf.codis = ariFilter.tipus.codi;
    }
    return;
  };

  var setParametersForEpri = function (ariFilter, paramsMapes) {
    paramsMapes.epri = {
      nivells: [],
      naturaleses: [],
      codis: ""
    };

    var epri = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'EPRILOE';
      });
      epri = ariFilter = ariFilter[index]
    }

    if (epri === null || epri === undefined) {
      return;
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.epri.nivells = extractField(ariFilter.nivells,
        'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.epri.naturaleses = extractField(
        ariFilter.naturaleses, 'id');
    }

    if (ariFilter.tipus.codi !== "") {
      paramsMapes.epri.codis = ariFilter.tipus.codi;
    }
    return;
  };

  var setParametersForEso = function (ariFilter, paramsMapes) {
    paramsMapes.eso = {
      nivells: [],
      naturaleses: [],
      codis: ""
    };

    var eso = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'ESOLOE';
      });
      eso = ariFilter = ariFilter[index]
    }

    if (eso === null || eso === undefined) {
      return;
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.eso.nivells = extractField(ariFilter.nivells,
        'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.eso.naturaleses = extractField(
        ariFilter.naturaleses, 'id');
    }

    if (ariFilter.tipus.codi !== "") {
      paramsMapes.eso.codis = ariFilter.tipus.codi;
    }
    return;
  };

  var setParametersForPFI = function (ariFilter, paramsMapes) {
    paramsMapes.pfi = {
      codi: '',
      estudis: [],
      families: [],
      naturaleses: [],
      nivells: [],
      torns: [],
    };

    var PFI = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'PFI';
      });
      PFI = ariFilter = ariFilter[index]
    }

    if (PFI === null || PFI === undefined) {
      return;
    }

    if (ariFilter.tipus) {
      paramsMapes.pfi.codi = ariFilter.tipus.codi;
    }

    if (!isEmpty(ariFilter.estudis)) {
      paramsMapes.pfi.estudis = _.some(ariFilter.estudis, 'codis') ? extractField(ariFilter.estudis, 'codis') : extractField(ariFilter.estudis, 'codi');
    }

    if (!isEmpty(ariFilter.families)) {
      paramsMapes.pfi.families = extractField(ariFilter.families, 'codi');
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.pfi.nivells = extractField(ariFilter.nivells, 'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.pfi.naturaleses = extractField(ariFilter.naturaleses, 'id');
    }

    if (!isEmpty(ariFilter.torns)) {
      paramsMapes.pfi.torns = extractField(ariFilter.torns, 'id');
    }

    return;
  };

  var setParametersForPFIE = function (ariFilter, paramsMapes) {
    paramsMapes.pfie = {
      codi: '',
      estudis: [],
      families: [],
      naturaleses: [],
      nivells: [],
      torns: [],
    };

    var PFIE = null;
    if (_.isArray(ariFilter) && ariFilter.length > 0) {
      var index = _.findIndex(ariFilter, function (o) {
        return o.tipus.codi === 'PFIE';
      });
      PFIE = ariFilter = ariFilter[index]
    }

    if (PFIE === null || PFIE === undefined) {
      return;
    }

    if (ariFilter.tipus) {
      paramsMapes.pfie.codi = ariFilter.tipus.codi;
    }

    if (!isEmpty(ariFilter.estudis)) {
      paramsMapes.pfie.estudis = _.some(ariFilter.estudis, 'codis') ? extractField(ariFilter.estudis, 'codis') : extractField(ariFilter.estudis, 'codi');
    }

    if (!isEmpty(ariFilter.families)) {
      paramsMapes.pfie.families = extractField(ariFilter.families, 'codi');
    }

    if (!isEmpty(ariFilter.nivells)) {
      paramsMapes.pfie.nivells = extractField(ariFilter.nivells, 'id');
    }

    if (!isEmpty(ariFilter.naturaleses)) {
      paramsMapes.pfie.naturaleses = extractField(ariFilter.naturaleses, 'id');
    }

    if (!isEmpty(ariFilter.torns)) {
      paramsMapes.pfie.torns = extractField(ariFilter.torns, 'id');
    }

    return;
  };

  $scope.search = function () {
    var bboxObj = {};
    $rootScope.cercaClick = true;
    paramsMapes.codiCentre = null;
    paramsMapes.nom = null;
    paramsMapes.codiServeiTerritorial = null;
    paramsMapes.codiComarca = null;
    paramsMapes.codiMunicipi = null;
    paramsMapes.codiDistricte = null;
    paramsMapes.codiNaturalesa = null;
    paramsMapes.ensenyaments = null;
    paramsMapes.ensenyamentsPreinscripcio = null;
    paramsMapes.acronim = null;
    paramsMapes.educacioEspecial = false;
    paramsMapes.sortBy = null;
    paramsMapes.sentitOrdre = 'asc';
    paramsMapes.curs = SharedProperties.getSelectedCurs();
    paramsMapes.rpp = 10;
    paramsMapes.pageActual = 1;
    paramsMapes.registreInicial = 1;
    paramsMapes.registreFinal = 10;

    NotificationsService.closeMessage();

    var ariFilter = EnsenyamentsPreinscripcioData.getAriFilter();
    var ensenyaments = EnsenyamentsPreinscripcioData.getEnsenyamentsFromAriFilter();
    var ensenyamentsPreinscripcio = _.uniqBy(Utils.findByEstudi(ensenyaments), 'id');
    var hiHaFormacioProfessional = Utils.hiHaFormacioProfessional(ariFilter);
    var nivells = EnsenyamentsPreinscripcioData.getNivellsFromAriFilter();

    var filter = "(1=1)";
    var isTerritorialFiltered = checkCommonFilter(
      DataService.comarca.codiComarca,
      DataService.municipi.codiMunicipi,
      DataService.serveisTerritorial.codiServeiTerritorial,
      DataService.districte.codiDistricte
    );
    var doSearch = checkSearchConditions(DataService.centre, ensenyaments, nivells, isTerritorialFiltered, hiHaFormacioProfessional);
    if (doSearch && checkCursSelected(paramsMapes.curs)) {
      if (DataService.cercarPer === 1) {
        if (!(/^\d+$/.test(DataService.centre.nomCentre))) {
          paramsMapes.nom = DataService.centre.nomCentre;
          paramsMapes.codiCentre = DataService.centre.codiCentre;
        } else {
          paramsMapes.nom = null;
          paramsMapes.codiCentre = DataService.centre.nomCentre;
        }

        if (paramsMapes.codiCentre !== null && paramsMapes.codiCentre
          !== "") {
          if (paramsMapes.codiCentre.length < 8) {
            filter += " AND (CODI_CENTRE ILIKE '%25"
              + paramsMapes.codiCentre + "%25' )";
          } else {
            filter += " AND (CODI_CENTRE= '" + paramsMapes.codiCentre
              + "' )";
          }
        }
        if (paramsMapes.nom !== null && paramsMapes.nom !== "") {
          var nomCentre = nomCentreParser(paramsMapes.nom);
          filter += " AND (NOM_ORDENAR ILIKE '%25" + nomCentre.replace(
            /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '') + "%25' )";
        }
        var aux = 0;
        var geoFilter = DataService.getFilter();
        if (geoFilter !== "") {
          filter += " AND ";
          filter += geoFilter;
        }

        for (var i in ariFilter) {
          var item = ariFilter[i];
          var estudis_item = _.map(_.uniqBy(Utils.findByEstudi(item.tipus), 'id'), 'id');
          if (aux === 0) {
            filter += " AND ((";
          } else {
            filter += " OR (";
          }

          if (estudis_item !== undefined) {
            filter += '(';
            for (var index in estudis_item) {
              filter += "(E='" + estudis_item[index] + "')";
              if (index < estudis_item.length - 1) {
                filter += " OR "
              }
            }
            filter += ')';
          }

          if (aux === ariFilter.length - 1) {
            filter += ')) ';
          } else {
            filter += ') ';
          }
          aux++;
        }

        var geoFilter2 = DataService.getFilter();
        if (geoFilter2 !== "") {
          filter += " AND ";
          filter += geoFilter2;
        }
        var selectedCurs = paramsMapes.curs;
        if (selectedCurs.length !== 0) {
          filter += " AND ( CURS IN ( " + paramsMapes.curs + " ) )";
        }

        ensenyamentsPreinscripcio = _.filter(ensenyamentsPreinscripcio,
          function (o) {
            if (!o.codi.match(/CFP/) && !o.codi.match(
              /CFA/) /*&& !o.codi.match(/ART/)*/ && !o.codi.match(
                /BATXLOE/)) {
              return o;
            }
          });
        paramsMapes.ensenyamentsPreinscripcio = EnsenyamentsPreinscripcioData.getElementsSQLFilter(
          ensenyamentsPreinscripcio);
      }
      setParametersForCfp(ariFilter, paramsMapes);
      setParametersForCfa(ariFilter, paramsMapes);
      setParametersForBatxillerat(ariFilter, paramsMapes);
      setParametersForEinf(ariFilter, paramsMapes);
      setParametersForEpri(ariFilter, paramsMapes);
      setParametersForEso(ariFilter, paramsMapes);
      setParametersForPFI(ariFilter, paramsMapes);
      setParametersForPFIE(ariFilter, paramsMapes);
      SharedProperties.setLastFilter(filter);

      paramsMapes.codiComarca = DataService.comarca.codiComarca;
      paramsMapes.codiMunicipi = DataService.municipi.codiMunicipi;
      paramsMapes.codiServeiTerritorial = DataService.serveisTerritorial.codiServeiTerritorial;
      paramsMapes.codiDistricte = DataService.districte.codiDistricte;

      $rootScope.$broadcast('searchInit');
      $rootScope.$broadcast('actionButtonInit');
      $rootScope.isSearching = true;
      if (DataService.cercarPer === 1) {
        CentresPreinscripcio.getCentresPreinscripcio(paramsMapes).then((result) => {
          DataService.listCentres.centres = result.centres;
          DataService.listCentres.totalItems = result.registresTotal;
          SharedProperties.setNumResults(result.registresTotal);
          bboxObj = setBBox();
          filter += " AND ( X IS NOT NULL )";
          filter += " AND ( Y IS NOT NULL)";
          CentresPreinscripcio.getCentresPreinscripcioCoordinates(paramsMapes).then((centersCoordinates) => {
            DataService.listEstudisVacants.estudis = centersCoordinates.centres;
            DataService.listEstudisVacants.totalItems = centersCoordinates.registresTotal;
            updatePreinscripcioMapWithResults(centersCoordinates.centres, bboxObj);
            $rootScope.$broadcast('searchDone');
            $rootScope.$broadcast('actionButtonDone');
          });
        });
      }
    } else {
      if (!paramsMapes.curs) {
        NotificationsService.sendMessage("Heu de seleccionar com a mínim un curs acadèmic", "info");
      } else {
        NotificationsService.sendMessage("Emplena algun camp per restringir la cerca", "info");
      }
      $rootScope.$broadcast('error');
    }
  };

  $scope.clear = function () {
    $rootScope.cercaClick = false;
    $rootScope.$broadcast('clear');
    $rootScope.$broadcast('changeActionButtonText', { text: 'Cerca' });
  };

  $scope.$on('searchPreinscripcio', function () {
    $scope.search();
  });

  function checkSearchConditions(codiCentre, ensenyaments, educacioEspecial,
    checkTerritori, hiHaFormacioProfessional) {
    if ((DataService.centre.codiCentre != null && DataService.centre.codiCentre !== "")
      || (DataService.centre.nomCentre != null && DataService.centre.nomCentre
        !== "")) {
      return true;
    } else {
      if (hiHaFormacioProfessional) {
        if (ensenyaments.length === 0) {
          return true;
        } else {
          return checkEducacioObligatoria(ensenyaments, educacioEspecial,
            checkTerritori)
        }
      } else {
        return checkEducacioObligatoria(ensenyaments, educacioEspecial,
          checkTerritori);
      }
    }
  }

  //Funció que comprova si es compleixen les condicions de cerca per ensenyaments obligatoris
  function checkEducacioObligatoria(ensenyaments, educacioEspecial,
    checkTerritori) {
    if (educacioEspecial.length === 0 && ensenyaments.length === 0) {
      if (checkTerritori === true) {
        return true;
      }
    } else if (educacioEspecial.length === 0 && ensenyaments.length > 0) {
      return ensenyaments.length > 0;
    } else if (educacioEspecial.length > 0 && ensenyaments.length === 0) {
      return educacioEspecial.length > 0;
    } else if (educacioEspecial.length > 0 && ensenyaments.length > 0) {
      return educacioEspecial.length > 0;
    }

  }

  //Funció que comprova si s'ha establert un filtre territorial
  function checkCommonFilter(codiComarca, codiMunicipi,
    codiServeiTerritorial, codiDistricte) {
    return !((codiComarca == null || codiComarca === "") && (codiMunicipi
      == null || codiMunicipi === "") && (codiServeiTerritorial == null
        || codiServeiTerritorial === "") && (codiDistricte == null
          || codiDistricte === ""));
  }

  function checkCursSelected(curs) {
    return curs !== "";
  }

  function conversioAccents(s) {
    if (!s) {
      return '';
    }
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function nomCentreParser(nom) {
    return (nom || '' )
      .replace(/ç/g, 'c')
      .replace(/ñ/g, 'n')
      .replace(/[ ,'·\-]/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  }

  //Funció per fer set del BBox del mapa en funció del filtre seleccionat
  function setBBox() {
    var bboxObj = {
      bboxGeo: [],
      bboxCentre: []
    };
    var bbox = '';
    var coordX = null;
    var coordY = null;
    var centres = $scope.lastMatchesFromNameInput;

    if (!((typeof DataService.centre.coordX === 'undefined' || DataService.centre.coordX
      === "") || (DataService.centre.coordY === "" || typeof DataService.centre.coordY
        === 'undefined'))) {
      coordX = DataService.centre.coordX;
      coordY = DataService.centre.coordY;
    } else if ((/^\d+$/.test(DataService.centre.nomCentre))) {
      var codiCentre = DataService.centre.nomCentre;
      var trobat = false;
      var i = 0;

      while (!trobat && centres != undefined && i < centres.length) {
        if (centres[i].codiCentre === codiCentre) {
          trobat = true;
          if (!((typeof centres[i].coordX === 'undefined'
            || centres[i].coordX === "") || (centres[i].coordY === ""
              || typeof centres[i].coordY === 'undefined'))) {
            coordX = centres[i].coordX;
            coordY = centres[i].coordY;
          }
        }
        i++;
      }
    }

    if ((coordX == null) || (coordY == null)) {
      if (DataService.serveisTerritorial.bbox !== ''
        && DataService.serveisTerritorial.bbox !== null) {
        bbox = (DataService.serveisTerritorial.bbox);

        if (DataService.municipi.bbox !== '' && DataService.municipi.bbox !== null) {
          bbox = DataService.municipi.bbox;
        }
        if (DataService.districte.bbox !== '' && DataService.districte.bbox !== null) {
          bbox = DataService.districte.bbox;
        }

      } else {
        if (DataService.comarca.bbox !== '' && DataService.comarca.bbox !== null) {
          bbox = DataService.comarca.bbox;
        }
        if (DataService.municipi.bbox !== '' && DataService.municipi.bbox !== null) {
          bbox = DataService.municipi.bbox;
        }
        if (DataService.districte.bbox !== '' && DataService.districte.bbox !== null) {
          bbox = DataService.districte.bbox;
        }
      }
      if (bbox !== '') {
        bboxObj.bboxGeo = bbox.split(",").map(Number);
      }
    } else {

      var offset = 100;
      coordX = Number((coordX).replace(",", "."));
      coordY = Number((coordY).replace(",", "."));

      var minX = coordX - offset;
      var minY = coordY - offset;
      var maxX = coordX + offset;
      var maxY = coordY + offset;

      bboxObj.bboxCentre = [minX, minY, maxX, maxY];

    }
    return bboxObj;
  }

  //TODO: Revisar que fa aquesta funció i a on s'utilitza, i en tot cas, adaptar a la cerca nova
  this.searchPreinscripcioUrl = function (codiComarca, codiEnsenyament) {

    var bboxObj = {};

    DataService.cercarPer = 1;
    var educacioEspecial = [];
    DataService.comarca.codiComarca = codiComarca;
    DataService.comarca.nomComarca = Comarques.getNomComarca($scope.comarques,
      codiComarca)
    var ensenyamentsPreinscripcio = codiEnsenyament;
    $scope.selectionEnsenyament = Utils.findByNomEnsenyament(
      EnsenyamentsData.ensenyaments, 'id', codiEnsenyament);

    //Inicialitzant els parametres de cerca.
    paramsMapes.codiCentre = null;
    paramsMapes.nom = null;
    paramsMapes.codiServeiTerritorial = null;
    paramsMapes.codiComarca = null;
    paramsMapes.codiMunicipi = null;
    paramsMapes.codiDistricte = null;
    paramsMapes.codiNaturalesa = null;
    paramsMapes.ensenyaments = null;
    paramsMapes.ensenyamentsPreinscripcio = null;
    paramsMapes.acronim = null;
    paramsMapes.educacioEspecial = false;
    paramsMapes.sortBy = null;
    paramsMapes.sentitOrdre = 'asc';
    paramsMapes.curs = SharedProperties.getSelectedCurs();
    paramsMapes.rpp = 10;
    paramsMapes.pageActual = 1;
    paramsMapes.registreInicial = 1;
    paramsMapes.registreFinal = 10;

    NotificationsService.closeMessage();
    var filter = "(1=1) ";
    var isTerritorialFiltered = checkCommonFilter(DataService.comarca.codiComarca,
      DataService.municipi.codiMunicipi,
      DataService.serveisTerritorial.codiServeiTerritorial,
      DataService.districte.codiDistricte)
    var doSearch = checkSearchConditions(DataService.cercarPer,
      DataService.centre.codiCentre, ensenyamentsPreinscripcio, educacioEspecial,
      isTerritorialFiltered);
    //Es realitzen comprovacions de diferents paràmetres, a més d'assegurar que el nivell estigui seleccionat
    if (doSearch && checkCursSelected(paramsMapes.curs)) {
      //Buscar per centre. Montamos los filtros para el geoserver
      if (DataService.cercarPer === 1) {
        //miramos si el valor en nomCentre no es numerico
        if (!(/^\d+$/.test(DataService.centre.nomCentre))) {
          paramsMapes.nom = DataService.centre.nomCentre;
          paramsMapes.codiCentre = DataService.centre.codiCentre;
        } else {
          paramsMapes.nom = null;
          paramsMapes.codiCentre = DataService.centre.nomCentre;
        }

        if (paramsMapes.codiCentre != null && paramsMapes.codiCentre
          != "") {
          if (paramsMapes.codiCentre.length < 8) {
            filter += " AND (CODI_CENTRE ILIKE '%25"
              + paramsMapes.codiCentre + "%25' )";
          } else {
            filter += " AND (CODI_CENTRE= '" + paramsMapes.codiCentre
              + "' )";
          }

        } else {

          if (paramsMapes.nom != null && paramsMapes.nom != "") {

            filter += " AND (NOM_CENTRE ILIKE '%"
              + (paramsMapes.nom).replace("'", "''") + "%' )";
          }

          if (ensenyamentsPreinscripcio.length > 0) {
            filter += " AND " + "E='" + ensenyamentsPreinscripcio + "' ";
          }
          var naturalesas = Utils.findBy(
            EnsenyamentsPreinscripcioData.naturalesas, 'value', true);
          if (naturalesas.length > 0) {
            filter += " AND ";
            filter += EnsenyamentsPreinscripcioData.getNaturalesasFilter(
              naturalesas);
            paramsMapes.codiNaturalesa = EnsenyamentsPreinscripcioData.getElementsSQLFilter(
              naturalesas);
          }
          var nivells = Utils.findBy(EnsenyamentsPreinscripcioData.nivell,
            'value', true);
          if (nivells.length > 0) {
            filter += " AND ";
            filter += EnsenyamentsPreinscripcioData.getNivellFilter(
              nivells);
            paramsMapes.codiNivell = EnsenyamentsPreinscripcioData.getElementsSQLFilter(
              nivells);
          }
          var geoFilter = DataService.getFilter()
          if (geoFilter != "") {
            filter += " AND ";
            filter += geoFilter;
          }
          var selectedCurs = paramsMapes.curs;
          if (selectedCurs.length != 0) {
            filter += " AND ( CURS IN ( " + paramsMapes.curs + " ) )";
          }
        }
        paramsMapes.ensenyamentsPreinscripcio = "'"
          + ensenyamentsPreinscripcio + "' ";

        //buscar per Serveis educatius
      }

      //guardem l'ultim filtre fet servir
      SharedProperties.setLastFilter(filter);

      //montamos los params geograficos
      paramsMapes.codiComarca = DataService.comarca.codiComarca;
      paramsMapes.codiMunicipi = DataService.municipi.codiMunicipi;
      paramsMapes.codiServeiTerritorial = DataService.serveisTerritorial.codiServeiTerritorial;
      paramsMapes.codiDistricte = DataService.districte.codiDistricte;

      //informamos que empezamos la búsqueda
      $rootScope.$broadcast('searchInit');
      $rootScope.$broadcast('actionButtonInit');
      if (DataService.cercarPer === 1) {
        CentresPreinscripcio.getCentresPreinscripcio(paramsMapes).then((result) => {
          DataService.listCentres.centres = result.centres;
          DataService.listCentres.totalItems = result.registresTotal;
          SharedProperties.setNumResults(result.registresTotal);
          //informos que la búsqueda finalizó
          $rootScope.$broadcast('searchDone');
          $rootScope.$broadcast('actionButtonDone');
        });
      }

      //informamos el mapa
      bboxObj = setBBox();
      updateMap(filter, bboxObj, 0);

    } else {
      if (!paramsMapes.curs) {
        NotificationsService.sendMessage("Heu de seleccionar com a mínim un curs acadèmic", "info");
      } else {
        NotificationsService.sendMessage("Emplena algun camp per restringir la cerca", "info");
      }
      $rootScope.$broadcast('error');
    }
  };
});
